import { useState } from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import {
  GridPagination,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector
} from '@mui/x-data-grid';

type Props = {};

function DataGridPagination(props: Props) {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const [isDesktop, setIsDesktop] = useState<boolean>(window.innerWidth > 880);

  const mobileMediaQuery = window.matchMedia('(max-width: 1017px)');
  const desktopMediaQuery = window.matchMedia('(min-width: 1018px)');

  mobileMediaQuery.onchange = (event) => {
    if (event.matches) setIsDesktop(false);
  };
  desktopMediaQuery.onchange = (event) => {
    if (event.matches) setIsDesktop(true);
  };

  const handleOnChange = (event: React.ChangeEvent<unknown>, value: number) => {
    apiRef.current.setPage(value - 1);
  };

  return (
    <Stack
      alignItems="center"
      direction="row"
      flexWrap="nowrap"
      justifyContent="space-between"
    >
      <Pagination
        color="primary"
        count={pageCount}
        onChange={handleOnChange}
        page={page + 1}
        siblingCount={isDesktop ? 1 : 0}
        size={isDesktop ? 'medium' : 'small'}
      />
      <GridPagination {...props} />
    </Stack>
  );
}

export default DataGridPagination;
